import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"

export default [
  {
    path: "/employees",
    name: "Company Employees",
    meta: { title: "Zaposleni" },
    component: () => import(/* webpackChunkName: "Company Employees List" */ "@/Modules/CompanyEmployee/Views/List/List"),
    children: [
      {
        path: "new",
        name: "New Company Employee",
        meta: { title: "Nov zaposleni" }
      },
      {
        path: "edit/:id",
        name: "Edit Company Employee (List)"
      }
    ],
    beforeEnter: ifAuthenticated
  },
  {
    path: "/employees/details/:id",
    name: "Company Employee Details",
    component: () => import(/* webpackChunkName: "Company Employee Details" */ "@/Modules/CompanyEmployee/Views/Details/Details"),
    children: [
      {
        path: "edit",
        name: "Edit Company Employee (Details)"
      }
    ],
    beforeEnter: ifAuthenticated
  }
]
